import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BreakPointService, ButtonComponent, Device } from '@woolworthsnz/styleguide';
import { SearchMediatorService } from '../search-mediator.service';
import { SearchPaginationComponent } from '../search-pagination/search-pagination.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
	selector: 'search-footer',
	templateUrl: './search-footer.component.html',
	styleUrls: ['./search-footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, ButtonComponent, SearchPaginationComponent, AsyncPipe],
})
export class SearchFooterComponent {
	@Input() itemsPerPageCollection: string[];
	@Input() totalItems: number;
	@Input() minimumPageSize: number;
	@Input() itemsCount: number;
	@Input() currentPage: number;
	@Input() currentPageSize: number;
	@Input() canChangePageSize: boolean;

	get showPagination(): boolean {
		return this.totalItems - this.currentPageSize * this.currentPage > 0;
	}

	device = Device;

	constructor(public breakPointService: BreakPointService, public searchMediatorService: SearchMediatorService) {}

	loadMore = (): void => this.searchMediatorService.emitLoadMoreEvent();

	scrollToTop = (): void => this.searchMediatorService.emitScrollToTopEvent();
}
